module.exports = __webpack_public_path__ + "img/page_01_logo.d1896e3e.png";